module.exports = __webpack_public_path__ + "media/images/e-bilet/Plus-2f50767c66d426352006aa0c09f11140.svg";